export default __webpack_public_path__ + "static/flex-beat-bg-fcf9e83f25c2ac9bc0c00c8c180069b0.png";